import { useEffect, useState } from "react";

// Clean digital countdown — bold Bebas, tight monospaced numerals, subtle red colon
// between units for drop emphasis. No flip animation, just crisp tick.
export default function Countdown({ target, caption, testid = "countdown" }) {
  const [remaining, setRemaining] = useState(() => getRemaining(target));
  useEffect(() => {
    const tick = () => setRemaining(getRemaining(target));
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  const cells = [
    { label: "DAYS", value: remaining.days },
    { label: "HOURS", value: remaining.hours },
    { label: "MINUTES", value: remaining.minutes },
    { label: "SECONDS", value: remaining.seconds },
  ];

  return (
    <div className="w-full" data-testid={testid}>
      <div className="flex items-start justify-center gap-4 md:gap-10">
        {cells.map((c, i) => (
          <div key={c.label} className="flex items-start">
            <div className="flex flex-col items-center min-w-[68px] md:min-w-[120px]">
              <div
                className="wc-heading text-white text-5xl md:text-8xl leading-none tabular-nums"
                data-testid={`${testid}-${c.label.toLowerCase()}`}
              >
                {String(c.value).padStart(2, "0")}
              </div>
              <div className="wc-label text-[10px] md:text-xs text-white/50 mt-3 tracking-[0.4em]">
                {c.label}
              </div>
            </div>
            {i < cells.length - 1 && (
              <div
                aria-hidden
                className="wc-heading text-5xl md:text-8xl leading-none gt-red opacity-70 mx-1 md:mx-3"
              >
                :
              </div>
            )}
          </div>
        ))}
      </div>
      {caption && (
        <p className="text-center wc-label text-xs text-white/50 tracking-[0.3em] mt-8">
          {caption}
        </p>
      )}
    </div>
  );
}

function getRemaining(target) {
  const now = Date.now();
  const diff = Math.max(0, new Date(target).getTime() - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff / 3600000) % 24);
  const minutes = Math.floor((diff / 60000) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}
